import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PeopleService {

  private url = environment.url;

  constructor(private http: HttpClient) { }

  getContactos() {
    return this.http.get(`${this.url}/personas/data/getContactos`);
  }
}
